import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import OrgSettingsPageContent from '@shared/components/organization/settings/OrgSettingsPageContent';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgSettingsPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, isLoading } = useCurrentOrgDetailsFetching();

    if (!currentOrg || isLoading) return <SpacedLoader />;
    return (
        <OrgPageTemplate>
            <PageHeader
                title={t('common:settings.orgTitle', { value: currentOrg?.name })}
                description={t('common:organization.settings.description')}
                items={items}></PageHeader>
            <OrgSettingsPageContent />
        </OrgPageTemplate>
    );
}
